/* Tracks scroll position and header heights.
   --g-header-h: the header section alone (transparent mode offset).
   --g-header-stack: everything above the page content (announcement bar +
   header + inline menu), so the hero can fill exactly the remaining viewport. */
(function () {
  var doc = document.documentElement;
  var section = document.querySelector('.section-header');
  var group = document.querySelectorAll('.shopify-section-group-header-group');

  function setHeights() {
    if (section) doc.style.setProperty('--g-header-h', section.offsetHeight + 'px');
    var stack = 0;
    group.forEach(function (s) { stack += s.offsetHeight; });
    if (stack > 0) doc.style.setProperty('--g-header-stack', stack + 'px');
  }
  function onScroll() {
    doc.classList.toggle('g-at-top', window.scrollY < 24);
  }

  /* Replace the wishlist app's chunky heart with the site's line heart. */
  var HEART_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 20.4C9.4 18.6 3 13.9 3 8.9 3 6.2 5.1 4.2 7.6 4.2c1.8 0 3.4 1 4.4 2.6 1-1.6 2.6-2.6 4.4-2.6 2.5 0 4.6 2 4.6 4.7 0 5-6.4 9.7-9 11.5z"/></svg>';
  function swapWishlistIcon() {
    document.querySelectorAll('a.wishlist-hero-header-icon').forEach(function (a) {
      if (!a.dataset.gHeart) {
        var svg = a.querySelector('svg');
        if (svg) { a.dataset.gHeart = '1'; svg.outerHTML = HEART_SVG; }
      }
    });
    // Kill the header count badge outright. The app forces it visible with
    // inline important styles when the wishlist has items, which CSS can't
    // beat, so remove the element every time it reappears.
    document
      .querySelectorAll('[class*="wishlist-hero-items-count"]')
      .forEach(function (el) { el.remove(); });
  }
  var icons = document.querySelector('.header__icons') || document.body;
  new MutationObserver(swapWishlistIcon).observe(icons, { childList: true, subtree: true });

  /* Give app-rendered controls accessible names (agent + a11y tree). */
  function labelAppControls() {
    document.querySelectorAll('select.stl-var-select:not([aria-label])').forEach(function (sel) {
      sel.setAttribute('aria-label', 'Choose an option');
    });
    // The product-page dropdown component replaces the native select.
    document.querySelectorAll('.stl-container .stl-var-select:not([data-g-vpicked])').forEach(function (sel) {
      sel.setAttribute('data-g-vpicked', '1');
      var wrap = document.createElement('div');
      wrap.className = 'g-vpick__control';
      var current = sel.options[sel.selectedIndex] ? sel.options[sel.selectedIndex].text : 'Select';
      var listHtml = '';
      for (var i = 0; i < sel.options.length; i++) {
        listHtml += '<li class="g-vpick__option' + (i === sel.selectedIndex ? ' g-vpick__option--selected' : '') + '" data-i="' + i + '"></li>';
      }
      wrap.innerHTML = '<button type="button" class="g-vpick__button" aria-haspopup="listbox" aria-expanded="false">' +
        '<span class="g-vpick__value"></span>' +
        '<span class="g-vpick__caret"><svg width="10" height="6" viewBox="0 0 10 6" fill="none" stroke="currentColor" stroke-width="1.2"><path d="M1 1l4 4 4-4"/></svg></span>' +
        '</button><ul class="g-vpick__list" role="listbox" hidden></ul>';
      wrap.querySelector('.g-vpick__value').textContent = current;
      var list = wrap.querySelector('.g-vpick__list');
      list.innerHTML = listHtml;
      list.querySelectorAll('.g-vpick__option').forEach(function (opt) {
        opt.textContent = sel.options[parseInt(opt.dataset.i, 10)].text;
      });
      sel.parentNode.insertBefore(wrap, sel);
      var btn = wrap.querySelector('.g-vpick__button');
      var value = wrap.querySelector('.g-vpick__value');
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = list.hidden;
        document.querySelectorAll('.stl-container .g-vpick__list').forEach(function (l) { l.hidden = true; });
        document.querySelectorAll('.stl-container .g-vpick__button').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
        list.hidden = !open;
        btn.setAttribute('aria-expanded', String(open));
      });
      list.querySelectorAll('.g-vpick__option').forEach(function (opt) {
        opt.addEventListener('click', function (e) {
          e.stopPropagation();
          sel.selectedIndex = parseInt(opt.dataset.i, 10);
          sel.dispatchEvent(new Event('change', { bubbles: true }));
          value.textContent = opt.textContent;
          list.querySelectorAll('.g-vpick__option').forEach(function (o) { o.classList.remove('g-vpick__option--selected'); });
          opt.classList.add('g-vpick__option--selected');
          list.hidden = true;
          btn.setAttribute('aria-expanded', 'false');
        });
      });
    });
  }
  document.addEventListener('click', function () {
    document.querySelectorAll('.stl-container .g-vpick__list').forEach(function (l) { l.hidden = true; });
    document.querySelectorAll('.stl-container .g-vpick__button').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  });
  new MutationObserver(labelAppControls).observe(document.body, { childList: true, subtree: true });


  /* Any add to cart, from any surface (apps, quick adds, blog cards),
     refreshes and opens the cart drawer. */
  (function () {
    var drawerBusy = false;
    function openDrawerFresh() {
      if (drawerBusy) return;
      var d = document.querySelector('cart-drawer');
      if (!d) return;
      drawerBusy = true;
      var shopRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
      if (typeof shopRoot !== 'string') { drawerBusy = false; return; }
      fetch(shopRoot.replace(/\/?$/, '/') + '?sections=cart-drawer,cart-icon-bubble')
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          if (sections['cart-drawer']) {
            var t = document.createElement('div');
            t.innerHTML = sections['cart-drawer'];
            var nd = t.querySelector('cart-drawer');
            if (nd) d.innerHTML = nd.innerHTML;
            d.classList.remove('is-empty');
          }
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble && sections['cart-icon-bubble']) bubble.innerHTML = sections['cart-icon-bubble'];
        })
        .catch(function () {})
        .then(function () {
          drawerBusy = false;
          if (typeof d.open === 'function') d.open();
          else { d.classList.add('animate', 'active'); document.body.classList.add('overflow-hidden'); }
        });
    }
    var origFetch = window.fetch;
    window.fetch = function () {
      var input = arguments[0];
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = origFetch.apply(this, arguments);
      if (String(url).indexOf('/cart/add') !== -1) {
        p.then(function (res) { if (res && res.ok) setTimeout(openDrawerFresh, 250); }).catch(function () {});
      }
      return p;
    };
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (String(url).indexOf('/cart/add') !== -1) {
        this.addEventListener('load', function () { if (this.status >= 200 && this.status < 300) setTimeout(openDrawerFresh, 250); });
      }
      return origOpen.apply(this, arguments);
    };
  })();

  setHeights();
  onScroll();
  swapWishlistIcon();
  labelAppControls();
  window.addEventListener('resize', setHeights);
  window.addEventListener('load', function () { setHeights(); swapWishlistIcon(); });
  window.addEventListener('scroll', onScroll, { passive: true });
})();
